<template>
    <div>
        <md-field>
            <label>{{ labelText }}</label>
            <TbSelect v-model="selectedValues" md-dense multiple
					  :search-allow="true"
					  :options="countryList"
					  options-value-field="code"
					  options-display-field="name"
					  ref="select"
			/>
        </md-field>
    </div>
</template>

<script>
import {commonApi} from "@/common/api/commonApi";
import {enumDef} from "@/common/enumDefs";

export default {
    props: {
        labelText: { type: String },
        columnName: { type: String },
        initialValues: { type: Array, default: [] },
        companyType: {type: Number, default: enumDef.companyType.TraderCompany}
    },
    data() {
        return {
            selectedValues: this.initialValues,
            countryList: [],
            enumDef: enumDef
        };
    },
    beforeMount() {
        this.getCountries();
    },
    methods: {
        getCountries() {
            commonApi.Companycountries(this.companyType)
                .then(res => {
                    // Translate the country code
                    res.forEach(item => item.name = this.$t(item.translationKey));

                    // Sort by country name
                    res.sort((c1, c2) => c1.name.localeCompare(c2.name));

                    this.countryList = res;
                })
                .catch(this.toast);
        },
        clearFilter() {
            this.selectedValues = [];
            this.$refs.select.resetSearch();
        },
        getFilter() {
            if (this.selectedValues.length === 0) {
                return null;
            }

            return [{
                columnName: this.columnName,
                fieldType: "S",
                matchType: "IN",
                value: this.selectedValues.join(",")
            }];
        },
        setFilter(filter) {
            this.selectedValues = filter.value.split(",");
        }
    }
};
</script>
